import { jsxs as l, jsx as v } from "react/jsx-runtime";
const r = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ v(
        "path",
        {
          fill: "currentColor",
          d: "M44.936 30.053h-2v4.487h2v-4.486ZM44.936 36.036h-2v4.487h2v-4.487ZM44.936 24.07h-2v4.488h2V24.07Z"
        }
      ),
      /* @__PURE__ */ v(
        "path",
        {
          fill: "currentColor",
          d: "M57.527 26.872c.139 0 .276.007.412.019v-9.434H6v9.417l.087-.002a4.838 4.838 0 0 1 0 9.677L6 36.546v9.997h49.006l-1.068-3.987 4-1.072V36.53a4.838 4.838 0 1 1-.412-9.658Zm-3.588-3.239c-3.09 1.379-5.25 4.48-5.25 8.077 0 3.597 2.16 6.699 5.25 8.077v2.756h-9.003v-.524h-2v.524H10v-2.908c2.916-1.446 4.926-4.455 4.926-7.925 0-3.47-2.01-6.478-4.926-7.924v-2.329h32.936v1.118h2v-1.118h9.003v2.176Z"
        }
      )
    ]
  }
);
export {
  r as Ticket
};
